export default "__VITE_ASSET__CJLjWl2X__"